<div class="sidebar">
  <div class="sidebar-top">
    <button class="dashboard-btn" (click)="goToDashboard()">Overview Dashboard</button>
  </div>

  <div class="sidebar-header">
    <h4>Conversation History</h4>
    <button class="new-btn" (click)="newConversation()" title="Start new conversation">
      + New
    </button>
  </div>

  <div class="current-conversation" *ngIf="getMessageCount() > 0 && !state.activeThreadId()">
    <div class="conversation-item active">
      <div class="conversation-title" [title]="getConversationTitle()">{{ getConversationTitle() }}</div>
    </div>
  </div>

  <div class="history-list" *ngIf="state.conversations().length">
    <div class="conversation-item" *ngFor="let conv of state.conversations()" [class.active]="isActive(conv.thread_id)"
      (click)="selectConversation(conv.thread_id)">
      <div class="conversation-title" [title]="conv.title">{{ conv.title }}</div>
      <button class="delete-btn" (click)="deleteConversation(conv.thread_id, $event)"
        title="Delete conversation">&times;</button>
    </div>
  </div>

  <div class="sidebar-actions">
    <button class="action-btn" (click)="clearHistory()">🗑️ Clear History</button>
  </div>

  <div class="sidebar-info">
    <p>Conversations are loaded from the database.</p>
  </div>
</div>